<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="sDate"
        :label="label"
        :rules="activeRules"
        :outlined="outlined"
        :hint="hint"
        :background-color="backgroundColor"
        :append-icon="appendIcon"
        :hide-details="hideDetails"
        persistent-hint
        :readonly="!typeable"
        :clearable="clearable"
        :dense="dense"
        :error-messages="error"
        v-bind="attrs"
        @blur="debounceChangeDate($event.target.value)"
        v-on="on"
      />
    </template>
    <v-date-picker
      :value="sDate"
      no-title
      scrollable
      :events="simplePubHolidays"
      event-color="red"
      @input="menu = false; debounceChangeDate($event)"
    />
  </v-menu>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { cutTime } from '../utils/datetimeUtil'
import { mapState } from 'vuex'
import { codeTableModule } from '../store/moduleName'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String, // YYYY-MM-DD
      default: null
    },
    outlined: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    backgroundColor: {
      type: String,
      default: undefined
    },
    appendIcon: {
      type: String,
      default: undefined
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    showLeave: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function () {
        return []
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // sDate: (this.value ? this.value.toISOString().substr(0, 10) : null),
      // sDateFormatted: ('AA: ' + this.value ? this.value.toISOString().substr(0, 10) : null),
      menu: false,
      error: null,
      typeable: this.$config.isWeb
    }
  },
  computed: {
    attrs: function () {
      const attrs = { ...this.$attrs }

      // adding class and style for `v-bind`
      attrs.class = this.$vnode.data.staticClass
      attrs.style = this.$vnode.data.staticStyle
      return attrs
    },
    sDate: function () {
      // return (this.value ? this.value.getFullYear() + '-' + (this.value.getMonth() + 1) + '-' + this.value.getDate() : null)
      return (this.value ? cutTime(this.value) : null)
    },
    activeRules: function () {
      // only validate text field when the date picker is closed
      if (!this.menu) {
        return this.rules
      } else {
        return []
      }
    },
    ...mapState({
      simplePubHolidays: state => state[codeTableModule].simplePubHolidays
    })
  },
  watch: {
    value: function () {
      this.menu = false
    }
  },
  created () {
    this.debounceChangeDate = _.debounce(this.changeDate, 300)
  },
  mounted () {
    // if (this.showLeave) {
    //   this.leaves = this.simplePubHolidays
    // }
  },
  methods: {
    changeDate: function (tDate) {
      // only emit input when date was changed
      let mDate = tDate
      if (mDate.trim() === '') {
        mDate = null
      }
      let isDateValid = mDate ? moment(mDate, 'YYYY-M-D', true).isValid() : true
      // console.log(isDateValid)
      if (!isDateValid) {
        mDate = null
        this.error = this.$t('PublicServant.Error.PubHoliday.InvalidDateString')
      } else {
        this.error = null
      }
      if (mDate !== this.sDate) {
        if (mDate) {
          this.$emit('input', moment(mDate).format('YYYY-MM-DD'))
        } else {
          this.$emit('input', null)
        }
      }
    }
  }
}
</script>
